import { HelpRounded as t } from "@mui/icons-material";
import { styled as p, css as e } from "./styled2.mjs";
const s = p(t)`
	color: ${({ theme: o }) => o.palette.action.active};
	cursor: pointer;
	${({ $size: o }) => o === "small" && e`
			font-size: 12px;
		`};
	${({ $size: o }) => o === "medium" && e`
			font-size: 16px;
		`};
	${({ $size: o }) => o === "large" && e`
			font-size: 24px;
		`};
`;
export {
  s as HelpIcon
};
//# sourceMappingURL=styles30.mjs.map
